<template>
  <el-dialog width="60%"
             :title="title"
             :visible.sync="viewDetail"
             :close-on-click-modal='false'
             @close="closeModel">
    <el-form :model="form"
             ref="form"
             :rules="rules">
      <el-form-item label="姓 名 :"
                    prop="username"
                    :label-width="formLabelWidth">
        <el-input v-model="form.username"
                  placeholder="请输入名字"
                  autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="账号名称 :"
                    prop="countName"
                    :label-width="formLabelWidth">
        <el-input v-model="form.countName"
                  placeholder="请输入手机号"
                  autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="账号密码 :"
                    prop="password"
                    :label-width="formLabelWidth"
                    v-if="title == '创建账号'">
        <el-input v-model="form.password"
                  placeholder="请输入账号密码"
                  autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="联系邮箱 :"
                    prop="email"
                    :label-width="formLabelWidth"
                   >
        <el-input v-model="form.email"
                  placeholder="请输入email"
                  autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="关联角色 :"
                    prop="roles"
                    :label-width="formLabelWidth">
        <el-select v-model="form.roles"
                   placeholder="请选择角色"
                   class="select">
          <el-option v-for="item in optionsList"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="closeModel">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit"
                 :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  mapActions
} from "vuex";
export default {
  props: {
    method: {
      type: Function
    },
    title: {
      type: String
    },
    detial_list: {
      type: Object
    },
  },
  data () {
    var isMobileNumber = (rules, value, callback) => {
      if (!value) {
        return new Error("请输入电话号码");
      } else {
        const reg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/;
        const isPhone = reg.test(value);
        value = Number(value); //转换为数字
        if (typeof value === "number" && !isNaN(value)) {
          //判断是否为数字
          value = value.toString(); //转换成字符串
          if (value.length < 0 || value.length > 12 || !isPhone) {
            //判断是否为11位手机号
            callback(new Error("手机号码格式如:138xxxx8754"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入电话号码"));
        }
      }
    };
    var validatePass = (ruless, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else {
        const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入6-20为字母和数字组合的密码"));
        }
      }
    };
    return {
      viewDetail: true,
      loading: false,
      formLabelWidth: '120px',
      optionsList: [],
      rolname: '',
      form: {
        username: "",
        password: "",
        countName: "",
        roles: "",
        email:''
      },
      rules: {
        username: [{ required: true, message: "填写内容不能为空！", trigger: "blur" }],
        // eslint-disable-next-line no-sparse-arrays
        countName: [
          { required: true, message: "填写内容不能为空！" },
          ,
          { validator: isMobileNumber, trigger: "blur" },
        ],
        password: [
          { required: true, message: "填写内容不能为空！", trigger: "blur" },
        ],
        roles: [{ required: true, message: "填写内容不能为空！" }],
           email: [{
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur"
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions({
      memeberCreate: "pressimApi/memeberCreate",
      excludeRoles: "pressimApi/excludeRoles",
      memeberEdit: "pressimApi/memeberEdit",
    }),
    closeModel () {
      this.$emit("closeModel");
    },
    //
    handleSubmit () {
      console.log(this.title,'this.title')
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.title == '创建账号') {
            this.initusermanageCreate()
          } else {
           this.initusermanageEdit()
          }

        } else {
          return false;
        }
      });
    },
    excludeRolesList () {
      let data = {
        token: this.$store.state.token,
        platform_id: 2,
      };
      this.excludeRoles(data).then((res) => {
        if (res.code === 1) {
          this.optionsList = res.data.list;
          if (this.title == '编辑账号'&& this.detial_list) {
            this.optionsList.forEach(el => {
              if (el.name == this.detial_list.role_name) {
                this.form.roles = el.id
              }
            })
          }

        } else {
          this.$message.error(res.msg);
        }
      }).catch(err=>console.log(err,'errr--'));
    },

    // //usermanageCreate
    initusermanageCreate () {
      this.loading = true
      const date = {
        token: this.$store.state.token,
        name: this.form.username, //姓名
        cellphone: this.form.countName, //手机号
        pwd: this.form.password, //密码
        role_id: this.form.roles, //角色id
        email: this.form.email, //email
        platform_id: 2,
      };
      this.memeberCreate(date).then(res => {
        this.loading = false
             console.log(res,'res-----')
        if (res.data.code == 1) {
     
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.method()
          this.closeModel()
        } else {
          this.$message.error({ message:res.data.msg })
        }
      })
    },
    initusermanageEdit () {
      this.loading = true
      const date = {
        token: this.$store.state.token,
        name: this.form.username, //姓名
        cellphone: this.form.countName, //手机号
      //  pwd: this.form.password, //密码
        role_id: this.form.roles, //角色id
        email: this.form.email, //email
        platform_id: 2,
        id:this.detial_list.id

      };

      this.memeberEdit(date).then(res => {
        this.loading = false
        if (res.data.code == 1) {
          this.$message({
            type: 'success',
            message:res.data.msg
          })
          this.method()
          this.closeModel()
        } else {
          this.$message.error({ message:res.data.msg })
        }
      })
    },

  },
  mounted () {
    console.log(this.title, 'detial_list')
    this.excludeRolesList()
    if (this.title == '编辑账号') {
      this.form.username = this.detial_list.real_name
      this.form.countName = this.detial_list.cellphones
      this.form.email = this.detial_list.emails
    }
  },
  components: {

  },
};
</script>

<style scoped lang="less">
</style>
